import React, { forwardRef, useRef } from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { DayPickerProps } from 'react-day-picker/types/Props';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import ReactDayPickerInput from './ReactDayPickerInput';

dayjs.extend(customParseFormat);

interface IReactDatePickerProps {
  value?: Date | string;
  placeholder?: string;
  onChange?: (dateString: string) => void;
  dayPickerProps?: DayPickerProps;
  onDayPickerShow?: () => void;
  onDayPickerHide?: () => void;
  onSubmit?: (day?: string) => void;
  disabled?: boolean;
}

const ReactDatePicker = ({ value, placeholder, onChange, dayPickerProps, onDayPickerShow, onDayPickerHide, onSubmit, disabled, ...rest }: IReactDatePickerProps) => {
  const ref = useRef<HTMLInputElement>(null);

  return (
    <DayPickerInput
      component={forwardRef((props, ref) => (
        <ReactDayPickerInput {...props} innerRef={ref} />
      ))}
      value={value}
      inputProps={{
        ref,
        onBlur: (e: React.FormEvent<HTMLInputElement>) => {
          onChange?.(e.currentTarget.value);
        },
        disabled,
      }}
      placeholder={placeholder || 'MM-DD-YYYY'}
      formatDate={(date: Date) => {
        if (dayjs(date).isValid()) {
          return dayjs(date).format('MM-DD-YYYY');
        }
        return value as string;
      }}
      parseDate={(str: string) => {
        const parsed = dayjs(str, 'MM-DD-YYYY', true);
        return parsed.isValid() ? parsed.toDate() : undefined;
      }}
      onDayChange={async (day: Date, _modifiers: any, dayPickerInput: DayPickerInput) => {
        if (day) {
          await onChange?.(dayjs(day).format('MM-DD-YYYY'));
          await onSubmit?.(dayjs(day).format('MM-DD-YYYY'));
          dayPickerInput.hideDayPicker();
        }
      }}
      dayPickerProps={dayPickerProps}
      onDayPickerShow={onDayPickerShow}
      onDayPickerHide={onDayPickerHide}
      {...rest}
    />
  );
};

export default ReactDatePicker;
